import type { MonospaceNamespace } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const Namespace = withItemType<MonospaceNamespace>().defineCollection({
	name: 'MonospaceNamespace',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: ['id', 'dbName', 'sourceId', 'isSystem'],
		endpoint: 'schema/structure/namespaces',
	},
});
